// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"currentNews_breadcrumbs__nKg49","contentWrapper":"currentNews_contentWrapper__waR00"};